import { Heart } from "lucide-react";

export function Brand({ className = "", subtitle = true, dark = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="gice-brand">
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#2C5545] text-white shadow-sm">
        <Heart className="h-5 w-5" strokeWidth={2.2} />
      </div>
      <div className="leading-tight">
        <div className={`font-heading text-lg font-bold tracking-tight ${dark ? "text-white" : "text-[#1F2924]"}`}>
          GIC&amp;E Inc.
        </div>
        {subtitle && (
          <div className={`text-[11px] uppercase tracking-[0.14em] ${dark ? "text-white/70" : "text-[#515E58]"}`}>
            Contractor Portal
          </div>
        )}
      </div>
    </div>
  );
}
